"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CONTENT_API_ENDPOINT = process.env.CONTENT_API_ENDPOINT || 'https://api-content.domru.ru/';
/**
 * Запрос в ApiContent
 */

var contentRequest = _axios["default"].create({
  baseURL: CONTENT_API_ENDPOINT
});

contentRequest.interceptors.request.use(function (config) {
  var isErtelecomHost = /t2.ertelecom.ru\/$/.test(config.baseURL);

  if (!process.browser && isErtelecomHost) {
    var https = require('https');

    config.httpsAgent = new https.Agent({
      rejectUnauthorized: false
    });
  }

  return config;
}, function (error) {
  return Promise.reject(error);
});
var _default = contentRequest;
exports["default"] = _default;